module.exports = __webpack_public_path__ + "img/3.b859e08.jpg";